import styled from 'styled-components';
import { MessageRole } from '../types/chat';

// 聊天容器样式
export const ChatContainer = styled.div`
    display: flex;
    flex-direction: column;
    height: 100vh; /* 回退方案 */
    height: -webkit-fill-available; /* iOS Safari */
    max-width: 450px;
    background-color: #fff;
    box-shadow: 0 0 10px rgba(0, 0, 0, 0.1);
    position: fixed;
    width: 100%;
    top: 0;
    left: 50%;
    transform: translateX(-50%);
    overflow: hidden; /* 防止内容溢出 */

    /* iOS Safari 视口适配 */
    @supports (-webkit-touch-callout: none) {
        height: -webkit-fill-available;
        /* 确保内容不会被底部工具栏遮挡 */
        padding-bottom: env(safe-area-inset-bottom);
    }
`;

// 聊天窗口样式
export const StyledChatWindow = styled.div`
    position: relative;
    flex: 1;
    overflow-y: auto;
    background-color: #f9f9f9;
    /* 防止iOS橡皮筋效果 */
    -webkit-overflow-scrolling: touch;
    overscroll-behavior: contain;
`;

// 消息容器样式
export const MessageContainer = styled.div<{ role: MessageRole }>`
    display: flex;
    align-items: flex-start;
    padding: 0 5px;
    margin: 5px 0;
    ${({ role }) => role === 'self' && 'flex-direction: row-reverse;'}
`;

// 头像样式
export const Avatar = styled.img`
    width: 40px;
    height: 40px;
    border-radius: 50%;
    margin: 0 10px;
`;

// 昵称样式
export const Nickname = styled.div`
    font-size: 0.8em;
    color: #555;
    margin-bottom: 3px;
`;

// 日期标签样式
export const DateLabel = styled.div`
    text-align: center;
    font-size: 0.8em;
    color: #888;
    margin: 10px 0;
`;

// 框容器样式
export const InputContainer = styled.div`
    display: flex;
    padding: 10px;
    background-color: #fff;
    border-top: 1px solid #eee;
`;

// 输入框样式
export const StyledInput = styled.textarea`
    flex: 1;
    padding: 10px;
    border: 1px solid #ddd;
    border-radius: 4px;
    resize: none;
    font-size: 14px;
    min-height: 40px;
    max-height: 120px;
    margin-right: 10px;

    &:focus {
        outline: none;
        border-color: #40a9ff;
    }
`;

// 发送按钮样式
export const SendButton = styled.button`
    padding: 0 20px;
    height: 40px;
    background-color: #1890ff;
    color: white;
    border: none;
    border-radius: 4px;
    cursor: pointer;
    font-size: 14px;

    &:hover {
        background-color: #40a9ff;
    }

    &:disabled {
        background-color: #d9d9d9;
        cursor: not-allowed;
    }
`;

// 消息内容容器样式
export const MessageContentContainer = styled.div<{ role: MessageRole }>`
    display: flex;
    flex-direction: column;
    align-items: ${({ role }) => role === 'self' ? 'flex-end' : 'flex-start'};
    width: 100%;

    // 添加文本消息和markdown消息的样式
    .text-message, .markdown-message {
        font-size: 14px;
        line-height: 1.6;
        color: #333;
    }
`;

// 输入容器样式
export const StyledInputContainer = styled.div`
    display: flex;
    flex-direction: column;
    padding: 10px;
    border-top: 1px solid #ccc;
    background-color: #f9f9f9;
`;

// 输入行样式
export const InputRow = styled.div`
    display: flex;
    align-items: center;
    background-color: #fff;
    border-radius: 25px;
    box-shadow: 0 2px 5px rgba(0, 0, 0, 0.1);
    padding: 5px 10px;
`;

// 输入框样式
export const StyledTextInput = styled.input`
    flex: 1;
    padding: 10px 15px;
    border: none;
    border-radius: 25px;
    outline: none;
    font-size: 16px;
    color: #333;
    background-color: transparent;

    &:disabled {
        background-color: #f5f5f5;
        cursor: not-allowed;
    }
`;

// 表情按钮样式
export const EmojiButton = styled.button`
    background: none;
    border: none;
    cursor: pointer;
    font-size: 20px;
    margin-right: 10px;
    &:hover {
        color: #007bff;
    }
    &:disabled {
        opacity: 0.5;
        cursor: not-allowed;
    }
`;

// 发送按钮样式
export const StyledSendButton = styled.button<{ $isLoading?: boolean }>`
    padding: 10px 15px;
    background-color: #007bff;
    color: white;
    border: none;
    border-radius: 25px;
    cursor: pointer;
    font-size: 16px;
    opacity: ${props => props.$isLoading ? 0.5 : 1};
    transition: all 0.3s ease;

    &:hover:not(:disabled) {
        background-color: #0056b3;
    }

    &:disabled {
        cursor: not-allowed;
    }
`; 